!function (e, a) {
  for (var t in a) {
    e[t] = a[t];
  }
}(exports, function (e) {
  var a = {};

  function t(n) {
    if (a[n]) return a[n].exports;
    var o = a[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = a, t.d = function (e, a, n) {
    t.o(e, a) || Object.defineProperty(e, a, {
      enumerable: !0,
      get: n
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, a) {
    if (1 & a && (e = t(e)), 8 & a) return e;
    if (4 & a && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & a && "string" != typeof e) for (var o in e) {
      t.d(n, o, function (a) {
        return e[a];
      }.bind(null, o));
    }
    return n;
  }, t.n = function (e) {
    var a = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(a, "a", a), a;
  }, t.o = function (e, a) {
    return Object.prototype.hasOwnProperty.call(e, a);
  }, t.p = "", t(t.s = 21);
}([function (e, a) {
  e.exports = require("react");
}, function (e, a) {
  e.exports = require("formik");
}, function (e, a) {
  e.exports = require("react-cookies");
}, function (e, a) {
  e.exports = function (e) {
    var a = [];
    return a.toString = function () {
      return this.map(function (a) {
        var t = function (e, a) {
          var t = e[1] || "",
              n = e[3];
          if (!n) return t;

          if (a && "function" == typeof btoa) {
            var o = (l = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(l)))) + " */"),
                r = n.sources.map(function (e) {
              return "/*# sourceURL=" + n.sourceRoot + e + " */";
            });
            return [t].concat(r).concat([o]).join("\n");
          }

          var l;
          return [t].join("\n");
        }(a, e);

        return a[2] ? "@media " + a[2] + "{" + t + "}" : t;
      }).join("");
    }, a.i = function (e, t) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var n = {}, o = 0; o < this.length; o++) {
        var r = this[o][0];
        "number" == typeof r && (n[r] = !0);
      }

      for (o = 0; o < e.length; o++) {
        var l = e[o];
        "number" == typeof l[0] && n[l[0]] || (t && !l[2] ? l[2] = t : t && (l[2] = "(" + l[2] + ") and (" + t + ")"), a.push(l));
      }
    }, a;
  };
}, function (e, a, t) {
  var n,
      o,
      r = {},
      l = (n = function n() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = n.apply(this, arguments)), o;
  }),
      i = function i(e, a) {
    return a ? a.querySelector(e) : document.querySelector(e);
  },
      c = function (e) {
    var a = {};
    return function (e, t) {
      if ("function" == typeof e) return e();

      if (void 0 === a[e]) {
        var n = i.call(this, e, t);
        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        a[e] = n;
      }

      return a[e];
    };
  }(),
      s = null,
      u = 0,
      m = [],
      p = t(10);

  function d(e, a) {
    for (var t = 0; t < e.length; t++) {
      var n = e[t],
          o = r[n.id];

      if (o) {
        o.refs++;

        for (var l = 0; l < o.parts.length; l++) {
          o.parts[l](n.parts[l]);
        }

        for (; l < n.parts.length; l++) {
          o.parts.push(b(n.parts[l], a));
        }
      } else {
        var i = [];

        for (l = 0; l < n.parts.length; l++) {
          i.push(b(n.parts[l], a));
        }

        r[n.id] = {
          id: n.id,
          refs: 1,
          parts: i
        };
      }
    }
  }

  function v(e, a) {
    for (var t = [], n = {}, o = 0; o < e.length; o++) {
      var r = e[o],
          l = a.base ? r[0] + a.base : r[0],
          i = {
        css: r[1],
        media: r[2],
        sourceMap: r[3]
      };
      n[l] ? n[l].parts.push(i) : t.push(n[l] = {
        id: l,
        parts: [i]
      });
    }

    return t;
  }

  function f(e, a) {
    var t = c(e.insertInto);
    if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var n = m[m.length - 1];
    if ("top" === e.insertAt) n ? n.nextSibling ? t.insertBefore(a, n.nextSibling) : t.appendChild(a) : t.insertBefore(a, t.firstChild), m.push(a);else if ("bottom" === e.insertAt) t.appendChild(a);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = c(e.insertAt.before, t);
      t.insertBefore(a, o);
    }
  }

  function h(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var a = m.indexOf(e);
    a >= 0 && m.splice(a, 1);
  }

  function E(e) {
    var a = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var n = function () {
        0;
        return t.nc;
      }();

      n && (e.attrs.nonce = n);
    }

    return g(a, e.attrs), f(e, a), a;
  }

  function g(e, a) {
    Object.keys(a).forEach(function (t) {
      e.setAttribute(t, a[t]);
    });
  }

  function b(e, a) {
    var t, n, o, r;

    if (a.transform && e.css) {
      if (!(r = a.transform(e.css))) return function () {};
      e.css = r;
    }

    if (a.singleton) {
      var l = u++;
      t = s || (s = E(a)), n = C.bind(null, t, l, !1), o = C.bind(null, t, l, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (e) {
      var a = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", g(a, e.attrs), f(e, a), a;
    }(a), n = k.bind(null, t, a), o = function o() {
      h(t), t.href && URL.revokeObjectURL(t.href);
    }) : (t = E(a), n = w.bind(null, t), o = function o() {
      h(t);
    });

    return n(e), function (a) {
      if (a) {
        if (a.css === e.css && a.media === e.media && a.sourceMap === e.sourceMap) return;
        n(e = a);
      } else o();
    };
  }

  e.exports = function (e, a) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (a = a || {}).attrs = "object" == typeof a.attrs ? a.attrs : {}, a.singleton || "boolean" == typeof a.singleton || (a.singleton = l()), a.insertInto || (a.insertInto = "head"), a.insertAt || (a.insertAt = "bottom");
    var t = v(e, a);
    return d(t, a), function (e) {
      for (var n = [], o = 0; o < t.length; o++) {
        var l = t[o];
        (i = r[l.id]).refs--, n.push(i);
      }

      e && d(v(e, a), a);

      for (o = 0; o < n.length; o++) {
        var i;

        if (0 === (i = n[o]).refs) {
          for (var c = 0; c < i.parts.length; c++) {
            i.parts[c]();
          }

          delete r[i.id];
        }
      }
    };
  };

  var y,
      N = (y = [], function (e, a) {
    return y[e] = a, y.filter(Boolean).join("\n");
  });

  function C(e, a, t, n) {
    var o = t ? "" : n.css;
    if (e.styleSheet) e.styleSheet.cssText = N(a, o);else {
      var r = document.createTextNode(o),
          l = e.childNodes;
      l[a] && e.removeChild(l[a]), l.length ? e.insertBefore(r, l[a]) : e.appendChild(r);
    }
  }

  function w(e, a) {
    var t = a.css,
        n = a.media;
    if (n && e.setAttribute("media", n), e.styleSheet) e.styleSheet.cssText = t;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(t));
    }
  }

  function k(e, a, t) {
    var n = t.css,
        o = t.sourceMap,
        r = void 0 === a.convertToAbsoluteUrls && o;
    (a.convertToAbsoluteUrls || r) && (n = p(n)), o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var l = new Blob([n], {
      type: "text/css"
    }),
        i = e.href;
    e.href = URL.createObjectURL(l), i && URL.revokeObjectURL(i);
  }
}, function (e, a) {
  e.exports = require("uuid/v4");
}, function (e, a, t) {
  e.exports = t(20);
}, function (e, a) {
  e.exports = require("react-datepicker");
}, function (e, a, t) {
  var n = t(9);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(4)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, a, t) {
  (e.exports = t(3)(!1)).push([e.i, ".form-radio__group ~ .invalid-feedback {\n    display: block;\n}", ""]);
}, function (e, a) {
  e.exports = function (e) {
    var a = "undefined" != typeof window && window.location;
    if (!a) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var t = a.protocol + "//" + a.host,
        n = t + a.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, a) {
      var o,
          r = a.trim().replace(/^"(.*)"$/, function (e, a) {
        return a;
      }).replace(/^'(.*)'$/, function (e, a) {
        return a;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r) ? e : (o = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? t + r : n + r.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}, function (e, a, t) {
  var n = t(12);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(4)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, a, t) {
  (e.exports = t(3)(!1)).push([e.i, ".form-radio__group--stacked {\n    flex-direction: column;\n}\n\n.form-radio__group--stacked > .form-radio__option.form-check {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    align-content: flex-start;\n    justify-content: center;\n}\n\n.form-radio__group--stacked > .form-radio__option.form-check > .form-control.form-radio__input {\n    flex-grow: 0;\n    flex-basis: 1rem;\n    margin-right: .5rem;\n}\n\n.form-radio__group--stacked > .form-radio__option.form-check > .form-radio__option-label {\n    flex-grow: 2;\n    font-weight: 500;\n}\n", ""]);
}, function (e, a, t) {
  var n = t(14);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(4)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, a, t) {
  (e.exports = t(3)(!1)).push([e.i, ".form-radio__group--inline {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.form-radio__group--inline > .form-radio__option.form-check {\n  display: flex;\n  max-width: 10rem;\n  flex-grow: 1;\n  align-items: center;\n  /* align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 0; */\n}\n\n.form-radio__group--inline\n  > .form-radio__option.form-check\n  > .form-control.form-radio__input {\n  /* flex-grow: 0;\n  flex-shrink: 0; */\n  flex-basis: 1rem;\n  margin-right: 0.5rem;\n}\n\n.form-radio__group--inline\n  > .form-radio__option.form-check\n  > .form-radio__option-label {\n  flex-grow: 1;\n  flex-shrink: 0;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n", ""]);
}, function (e, a) {
  e.exports = require("react-datepicker/dist/react-datepicker.css");
}, function (e, a, t) {
  var n = t(17);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(4)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, a, t) {
  (e.exports = t(3)(!1)).push([e.i, ".react-datepicker-wrapper {\n    display: flex;\n    max-width: 15rem;\n    align-items: flex-start;\n    position: relative;\n}\n\n.react-datepicker__input-container {\n    width: 100%;\n}\n\n.datepicker-wrapper {\n    position: relative;\n    width: 100%;\n}\n\n.datepick-trigger {\n    left: 13.3rem;\n    position: absolute;\n    top: 0.65rem;\n}\n\n.datepicker-wrapper .invalid-feedback {\n    display: inline-block;\n}", ""]);
}, function (e, a, t) {
  var n = t(19);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(4)(n, o);
  n.locals && (e.exports = n.locals);
}, function (e, a, t) {
  (e.exports = t(3)(!1)).push([e.i, ".auth-container {\n  margin-bottom: 1.5rem;\n}\n\n.form-bg {\n  background-color: #ecf1f5;\n  padding: 1rem;\n  border-radius: 3px;\n  max-width: 50rem;\n  margin: 0 auto;\n  border-top: 0.5rem solid #dfe6ec;\n}\n\n.form-short {\n  max-width: 30em;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n", ""]);
}, function (e, a) {
  e.exports = require("regenerator-runtime");
}, function (e, a, t) {
  "use strict";

  function n() {
    return (n = Object.assign || function (e) {
      for (var a = 1; a < arguments.length; a++) {
        var t = arguments[a];

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function o(e, a) {
    if (null == e) return {};

    var t,
        n,
        o = function (e, a) {
      if (null == e) return {};
      var t,
          n,
          o = {},
          r = Object.keys(e);

      for (n = 0; n < r.length; n++) {
        t = r[n], a.indexOf(t) >= 0 || (o[t] = e[t]);
      }

      return o;
    }(e, a);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);

      for (n = 0; n < r.length; n++) {
        t = r[n], a.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
      }
    }

    return o;
  }

  function r(e, a) {
    if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
  }

  function l(e, a) {
    for (var t = 0; t < a.length; t++) {
      var n = a[t];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function i(e, a, t) {
    return a && l(e.prototype, a), t && l(e, t), e;
  }

  function c(e) {
    return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function s(e) {
    return (s = "function" == typeof Symbol && "symbol" === c(Symbol.iterator) ? function (e) {
      return c(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : c(e);
    })(e);
  }

  function u(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function m(e, a) {
    return !a || "object" !== s(a) && "function" != typeof a ? u(e) : a;
  }

  function p(e) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function d(e, a) {
    return (d = Object.setPrototypeOf || function (e, a) {
      return e.__proto__ = a, e;
    })(e, a);
  }

  function v(e, a) {
    if ("function" != typeof a && null !== a) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(a && a.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), a && d(e, a);
  }

  t.r(a);

  var f = t(0),
      h = t.n(f),
      E = t(1),
      g = function (e) {
    function a(e) {
      var t;
      return r(this, a), t = m(this, p(a).call(this, e)), console.log(t.props), t.state = {
        hello: "World!",
        isChecked: t.props.initialValue
      }, t;
    }

    return v(a, e), i(a, [{
      key: "render",
      value: function value() {
        var e = this.props,
            a = e.htmlId,
            t = e.fieldName,
            r = e.labelText,
            l = e.validate,
            i = e.className,
            c = e.onChange,
            s = (e.values, o(e, ["htmlId", "fieldName", "labelText", "validate", "className", "onChange", "values"]));
        return h.a.createElement("div", {
          className: "form-group col ".concat(i || "")
        }, h.a.createElement("div", {
          className: "form-check"
        }, h.a.createElement("label", {
          htmlFor: a,
          className: "form-check-label"
        }, r, h.a.createElement(E.Field, n({
          name: t
        }, s, {
          validate: l
        }), function (e) {
          var t = e.field,
              o = e.form,
              r = o.touched,
              l = o.errors,
              i = o.setFieldValue,
              u = "";
          r[t.name] && (u = l[t.name] ? "is-invalid" : "is-valid");
          return h.a.createElement("input", n({
            type: "checkbox",
            id: a,
            value: t.value,
            checked: t.value,
            className: "form-control form-check-input ".concat(u)
          }, s, t, {
            onChange: function onChange(e) {
              i(t.name, !!e.target.checked), "function" == typeof c && c({
                name: t.name,
                value: !!e.target.checked
              });
            }
          }));
        }), h.a.createElement(E.ErrorMessage, {
          id: "".concat(a, "-error-message"),
          component: "span",
          className: "invalid-feedback",
          name: t
        }))));
      }
    }]), a;
  }(h.a.Component),
      b = (t(8), function (e) {
    var a = e.htmlId,
        t = e.fieldName,
        r = e.value,
        l = e.name,
        i = (e.className, e.validate),
        c = e.onChange,
        s = o(e, ["htmlId", "fieldName", "value", "name", "className", "validate", "onChange"]);
    return h.a.createElement(E.Field, n({
      name: t
    }, s, {
      validate: i
    }), function (e) {
      var o = e.field,
          i = e.form.setFieldValue;
      return h.a.createElement("div", {
        className: "form-check form-radio__option"
      }, h.a.createElement("input", n({}, o, {
        className: "form-radio__input form-control",
        type: "radio",
        id: "".concat(a, "-").concat(r),
        value: r,
        checked: o.value === r,
        name: t,
        onChange: function onChange(e) {
          i(o.name, r), "function" == typeof c && c({
            name: o.name,
            value: r
          });
        }
      })), h.a.createElement("label", {
        className: "form-radio__option-label",
        htmlFor: "".concat(a, "-").concat(r)
      }, l));
    });
  }),
      y = (t(11), function (e) {
    var a = e.htmlId,
        t = e.fieldName,
        r = e.labelText,
        l = e.validate,
        i = e.className,
        c = e.options,
        s = e.onChange,
        u = e.touched,
        m = e.errors,
        p = o(e, ["htmlId", "fieldName", "labelText", "validate", "className", "options", "onChange", "touched", "errors"]),
        d = "";
    return u[t] && (d = m[t] ? "is-invalid" : "is-valid"), h.a.createElement("div", {
      className: "form-group col flex-column".concat(i || "")
    }, h.a.createElement("label", {
      className: "form-radio__label"
    }, r), h.a.createElement("div", {
      className: "form-radio__group form-radio__group--stacked ".concat(d)
    }, c.map(function (e) {
      return h.a.createElement(b, n({
        key: "".concat(a, "-").concat(e.value),
        value: e.value,
        name: e.name,
        htmlId: a,
        fieldName: t,
        validate: l,
        className: i,
        onChange: s
      }, p));
    })), h.a.createElement(E.ErrorMessage, {
      id: "".concat(a, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: t
    }));
  }),
      N = (t(13), function (e) {
    var a = e.htmlId,
        t = e.fieldName,
        r = e.labelText,
        l = e.validate,
        i = e.className,
        c = e.options,
        s = e.onChange,
        u = e.touched,
        m = e.errors,
        p = o(e, ["htmlId", "fieldName", "labelText", "validate", "className", "options", "onChange", "touched", "errors"]),
        d = "";
    return u[t] && (d = m[t] ? "is-invalid" : "is-valid"), h.a.createElement("div", {
      className: "form-group col flex-column".concat(i || "")
    }, h.a.createElement("label", {
      className: "form-radio__label"
    }, r), h.a.createElement("div", {
      className: "form-radio__group form-radio__group--inline ".concat(d)
    }, c.map(function (e) {
      return h.a.createElement(b, n({
        key: "".concat(a, "-").concat(e.value),
        value: e.value,
        name: e.name,
        htmlId: a,
        fieldName: t,
        validate: l,
        className: i,
        onChange: s
      }, p));
    })), h.a.createElement(E.ErrorMessage, {
      id: "".concat(a, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: t
    }));
  }),
      C = function C(e) {
    var a = e.htmlId,
        t = e.fieldName,
        r = e.labelText,
        l = e.validate,
        i = e.className,
        c = (e.isValid, e.onChange),
        s = o(e, ["htmlId", "fieldName", "labelText", "validate", "className", "isValid", "onChange"]);
    return h.a.createElement("div", {
      className: "form-group col flex-column ".concat(i || "")
    }, h.a.createElement("label", {
      htmlFor: a
    }, r), h.a.createElement(E.Field, n({
      name: t,
      validate: l
    }, s), function (e) {
      var t = e.field,
          o = e.form,
          r = o.touched,
          l = o.errors,
          i = o.setFieldValue,
          u = "";
      r[t.name] && (u = l[t.name] ? "is-invalid" : "is-valid");
      return h.a.createElement("input", n({
        type: "text",
        id: a,
        className: "form-control ".concat(u)
      }, s, t, {
        onChange: function onChange(e) {
          i(t.name, e.target.value), "function" == typeof c && c({
            name: t.name,
            value: e.target.value
          });
        }
      }));
    }), h.a.createElement(E.ErrorMessage, {
      id: "".concat(a, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: t
    }));
  },
      w = t(5),
      k = t.n(w),
      S = function S(e) {
    var a = e.htmlId,
        t = e.fieldName,
        r = e.labelText,
        l = e.validate,
        i = e.className,
        c = e.options,
        s = e.optionGroups,
        u = e.defaultOption,
        m = e.onChange,
        p = o(e, ["htmlId", "fieldName", "labelText", "validate", "className", "options", "optionGroups", "defaultOption", "onChange"]),
        d = function d(e) {
      return h.a.createElement("option", {
        key: k()(),
        value: e.value
      }, e.name);
    },
        v = [];

    return s ? s.forEach(function (e) {
      var a = e.options.map(d),
          t = h.a.createElement("optgroup", {
        label: e.label,
        key: k()()
      }, a);
      v.push(t);
    }) : v = c.map(d), u || (u = h.a.createElement("option", {
      value: "",
      key: k()()
    }, "- Select -")), h.a.createElement("div", {
      className: "form-group col flex-column ".concat(i || "")
    }, h.a.createElement("label", {
      htmlFor: a
    }, r), h.a.createElement(E.Field, n({
      name: t,
      validate: l
    }, p), function (e) {
      var t = e.field,
          o = e.form,
          r = o.touched,
          l = o.errors,
          i = o.setFieldValue,
          c = "";
      r[t.name] && (c = l[t.name] ? "is-invalid" : "is-valid");
      return h.a.createElement("select", n({
        id: a,
        className: "form-control ".concat(c)
      }, p, t, {
        onChange: function onChange(e) {
          i(t.name, e.target.value), "function" == typeof m && m({
            name: t.name,
            value: e.target.value
          });
        }
      }), u, v);
    }), h.a.createElement(E.ErrorMessage, {
      id: "".concat(a, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: t
    }));
  },
      x = t(7),
      I = t.n(x),
      M = (t(15), t(16), function (e) {
    var a = e.fieldName,
        t = e.labelText,
        r = e.htmlId,
        l = e.className,
        i = e.validate,
        c = e.onChange,
        s = o(e, ["fieldName", "labelText", "htmlId", "className", "validate", "onChange"]);
    return h.a.createElement("div", {
      className: "form-group col flex-column ".concat(l || "")
    }, h.a.createElement("label", {
      htmlFor: r
    }, t), h.a.createElement(E.Field, n({
      name: a,
      validate: i
    }, s), function (e) {
      var t = e.field,
          o = e.form,
          l = o.touched,
          i = o.errors,
          u = o.setFieldValue,
          m = o.setFieldTouched,
          p = "";
      l[t.name] && (p = i[t.name] ? "is-invalid" : "is-valid");

      var d = function d(e) {
        u(t.name, e), "function" == typeof c && c({
          name: t.name,
          value: e
        });
      };

      return h.a.createElement("div", {
        className: "datepicker-wrapper"
      }, h.a.createElement(I.a, n({}, s, {
        onChange: d,
        onSelect: d,
        onBlur: function onBlur() {
          return m(t.name, !0);
        },
        selected: t.value && t.value,
        autoComplete: "off",
        id: r,
        className: "form-control ".concat(p),
        name: a
      })), h.a.createElement(E.ErrorMessage, {
        id: "".concat(r, "-error-message"),
        component: "span",
        className: "invalid-feedback",
        name: a
      }), h.a.createElement("img", {
        src: "//cdn.thomasnet.com/images/rfi/images/calender_icon.png",
        alt: "Choose date",
        className: "datepick-trigger"
      }));
    }));
  }),
      F = function F(e) {
    var a = e.htmlId,
        t = e.fieldName,
        r = e.labelText,
        l = e.validate,
        i = e.className,
        c = e.rows,
        s = e.cols,
        u = e.onChange,
        m = o(e, ["htmlId", "fieldName", "labelText", "validate", "className", "rows", "cols", "onChange"]);
    return h.a.createElement("div", {
      className: "form-group flex-column col ".concat(i || "")
    }, h.a.createElement("label", {
      htmlFor: a
    }, r), h.a.createElement(E.Field, n({
      name: t,
      validate: l
    }, m), function (e) {
      var t = e.field,
          o = e.form,
          r = o.touched,
          l = o.errors,
          i = o.setFieldValue,
          p = "";
      r[t.name] && (p = l[t.name] ? "is-invalid" : "is-valid");
      return h.a.createElement("textarea", n({
        id: a,
        className: "form-control ".concat(p),
        rows: c || 3,
        cols: s || 25
      }, m, t, {
        onChange: function onChange(e) {
          i(t.name, e.target.value), "function" == typeof u && u({
            name: t.name,
            value: e.target.value
          });
        }
      }));
    }), h.a.createElement(E.ErrorMessage, {
      id: "".concat(a, "-error-message"),
      component: "span",
      className: "invalid-feedback",
      name: t
    }));
  };

  function P(e, a, t) {
    return a in e ? Object.defineProperty(e, a, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[a] = t, e;
  }

  var T = function (e) {
    function a(e) {
      var t;
      return r(this, a), P(u(t = m(this, p(a).call(this, e))), "clearInput", function () {
        t.inputRef.current.value = null;
      }), P(u(t), "sendInput", function (e) {
        t.props.onChange(e), t.clearInput();
      }), t.inputRef = h.a.createRef(), t;
    }

    return v(a, e), i(a, [{
      key: "render",
      value: function value() {
        return h.a.createElement("div", {
          style: {
            zIndex: 0,
            position: "relative"
          }
        }, h.a.createElement("label", {
          className: "custom-file-label",
          htmlFor: "customFile",
          style: {
            zIndex: 0
          }
        }, "Choose file"), h.a.createElement("input", {
          className: "custom-file-input",
          type: "file",
          name: "rfi-attachment",
          onChange: this.sendInput,
          ref: this.inputRef
        }));
      }
    }]), a;
  }(f.Component),
      O = function O(e) {
    var a = e.files,
        t = e.deleteFile,
        n = e.className,
        o = e.isUploading;
    return h.a.createElement("ul", {
      id: "fileCont",
      className: "".concat(n)
    }, o ? h.a.createElement("li", {
      key: "01239123192",
      className: "fileAttachSwapContent displayUploadedFile"
    }, h.a.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
      }
    }, h.a.createElement("div", {
      className: "spinner spinner--page-loading"
    }, h.a.createElement("div", {
      className: "rect1"
    }), h.a.createElement("div", {
      className: "rect2"
    }), h.a.createElement("div", {
      className: "rect3"
    }), h.a.createElement("div", {
      className: "rect4"
    }), h.a.createElement("div", {
      className: "rect5"
    })))) : null, a.map(function (e) {
      var a = e.key,
          n = e.fileName;
      return h.a.createElement("li", {
        key: a,
        className: "fileAttachSwapContent displayUploadedFile"
      }, h.a.createElement("span", {
        className: "req",
        onClick: function onClick() {
          return t(a);
        }
      }, "×"), h.a.createElement("a", {
        href: "#",
        className: "rfi-attachment__link"
      }, n));
    }));
  },
      _ = function (e) {
    function a() {
      var e, t;
      r(this, a);

      for (var n = arguments.length, o = new Array(n), l = 0; l < n; l++) {
        o[l] = arguments[l];
      }

      return P(u(t = m(this, (e = p(a)).call.apply(e, [this].concat(o)))), "onChange", function (e) {
        var a = e.target.files[0];
        t.props.onFileUpload(a);
      }), t;
    }

    return v(a, e), i(a, [{
      key: "render",
      value: function value() {
        return h.a.createElement("div", {
          className: "form-group col flex-column",
          style: {
            maxWidth: "35rem",
            minWidth: " 15rem"
          }
        }, h.a.createElement("div", {
          className: "custom-file"
        }, h.a.createElement("div", {
          id: "fileUploadSwapArea",
          style: {
            width: "100%"
          }
        }, h.a.createElement(T, {
          onChange: this.onChange,
          className: "custom-file-input"
        }), h.a.createElement(O, {
          isUploading: this.props.isUploading,
          files: this.props.files,
          deleteFile: this.props.deleteFile
        }))));
      }
    }]), a;
  }(f.Component),
      A = function A(e) {
    var a = e.text;
    return h.a.createElement("button", null, a);
  },
      U = function (e) {
    function a() {
      var e;
      return r(this, a), (e = m(this, p(a).call(this))).state = {
        password: "",
        confirmpassword: "",
        confirmationcode: "",
        localerror: ""
      }, e;
    }

    return v(a, e), i(a, [{
      key: "render",
      value: function value() {
        var e = this,
            a = this.props,
            t = a.email,
            n = a.onConfirmForgotPassword,
            o = a.loading,
            r = a.error,
            l = this.state.localerror;
        return h.a.createElement("div", {
          className: "auth-container"
        }, h.a.createElement("div", {
          className: "form-bg form-short"
        }, (r || l) && h.a.createElement("p", {
          className: "alert alert-danger hide",
          id: "errMsg",
          style: {
            display: "block"
          }
        }, l || r), h.a.createElement("p", {
          className: "text-center"
        }, h.a.createElement("b", null, t), h.a.createElement("br", null), h.a.createElement("a", {
          href: "#not-you",
          onClick: function onClick(e) {
            return e.preventDefault();
          }
        }, "Not You?")), h.a.createElement("div", {
          className: "form-group",
          style: {
            position: "relative"
          }
        }, h.a.createElement("label", {
          htmlFor: "exampleInputPassword1"
        }, "Enter the confirmation code"), h.a.createElement("input", {
          className: "form-control",
          placeholder: "Confirmation Code",
          value: this.state.confirmationcode,
          onChange: function onChange(a) {
            return e.setState({
              confirmationcode: a.target.value
            });
          }
        })), h.a.createElement("div", {
          className: "form-group",
          style: {
            position: "relative"
          }
        }, h.a.createElement("label", {
          htmlFor: "exampleInputPassword1"
        }, "Enter your password"), h.a.createElement("input", {
          name: "password",
          type: "password",
          className: "form-control ".concat(l ? "is-invalid" : ""),
          placeholder: "Password",
          value: this.state.password,
          onChange: function onChange(a) {
            return e.setState({
              password: a.target.value,
              localerror: l ? a.target.value === e.state.confirmpassword ? "" : "Passwords do not match" : l
            });
          }
        })), h.a.createElement("div", {
          className: "form-group",
          style: {
            position: "relative"
          }
        }, h.a.createElement("label", {
          htmlFor: "exampleInputPassword1"
        }, "Confirm your password"), h.a.createElement("input", {
          name: "confirmpassword",
          type: "password",
          className: "form-control ".concat(l ? "is-invalid" : ""),
          placeholder: "Confirm Password",
          value: this.state.confirmpassword,
          onChange: function onChange(a) {
            return e.setState({
              confirmpassword: a.target.value,
              localerror: l ? a.target.value === e.state.password ? "" : "Passwords do not match" : l
            });
          }
        })), h.a.createElement("div", {
          className: "form-group flex-end-btn"
        }, h.a.createElement("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: function onClick() {
            e.state.password === e.state.confirmpassword ? (e.setState({
              localerror: ""
            }), n(t, e.state.password, e.state.confirmationcode)) : e.setState({
              localerror: "Passwords do not match"
            });
          }
        }, o ? h.a.createElement("div", {
          className: "spinner loading-white"
        }, h.a.createElement("div", {
          className: "rect1"
        }), h.a.createElement("div", {
          className: "rect2"
        }), h.a.createElement("div", {
          className: "rect3"
        }), h.a.createElement("div", {
          className: "rect4"
        }), h.a.createElement("div", {
          className: "rect5"
        })) : "Confirm")), h.a.createElement("p", {
          className: "alert alert-success",
          id: "errMsg",
          style: {
            display: "block"
          }
        }, "Password reset instructions have been emailed to you.")));
      }
    }]), a;
  }(h.a.Component),
      j = (t(18), function (e) {
    function a() {
      var e;
      return r(this, a), (e = m(this, p(a).call(this))).state = {
        password: ""
      }, e;
    }

    return v(a, e), i(a, [{
      key: "render",
      value: function value() {
        var e = this,
            a = this.props,
            t = a.onSignIn,
            n = a.email,
            o = a.loading,
            r = void 0 !== o && o,
            l = a.onForgotPassword,
            i = a.error;
        return h.a.createElement("div", {
          className: "auth-container"
        }, h.a.createElement("div", {
          className: "form-bg form-short"
        }, i && h.a.createElement("p", {
          className: "alert alert-danger hide",
          id: "errMsg",
          style: {
            display: "block"
          }
        }, i), h.a.createElement("p", {
          className: "text-center"
        }, h.a.createElement("b", null, n || "test@gmail.com"), h.a.createElement("br", null), h.a.createElement("a", {
          href: "#not-you",
          onClick: function onClick(e) {
            return e.preventDefault();
          }
        }, "Not You?")), h.a.createElement("div", {
          className: "form-group",
          style: {
            position: "relative"
          }
        }, h.a.createElement("label", {
          htmlFor: "exampleInputPassword1"
        }, "Enter your password"), h.a.createElement("input", {
          name: "password",
          type: "password",
          className: "form-control",
          placeholder: "password",
          value: this.state.password,
          onChange: function onChange(a) {
            return e.setState({
              password: a.target.value
            });
          },
          onKeyPress: function onKeyPress(a) {
            (a.keyCode || 13 === a.which) && t(n, e.state.password);
          }
        }), h.a.createElement("a", {
          className: "forgot-password-link",
          onClick: function onClick(e) {
            e.preventDefault(), l();
          },
          href: "#forgot-password-link"
        }, "Forgot Password?")), h.a.createElement("div", {
          className: "form-group flex-end-btn"
        }, h.a.createElement("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: function onClick() {
            return t(n, e.state.password);
          }
        }, r ? h.a.createElement("div", {
          className: "spinner loading-white"
        }, h.a.createElement("div", {
          className: "rect1"
        }), h.a.createElement("div", {
          className: "rect2"
        }), h.a.createElement("div", {
          className: "rect3"
        }), h.a.createElement("div", {
          className: "rect4"
        }), h.a.createElement("div", {
          className: "rect5"
        })) : "Sign In"))));
      }
    }]), a;
  }(h.a.Component)),
      L = /^\S+@\S+$/g,
      R = function (e) {
    function a() {
      var e;
      return r(this, a), (e = m(this, p(a).call(this))).state = {
        email: "",
        error: ""
      }, e.checkForValidEmail = e.checkForValidEmail.bind(u(e)), e;
    }

    return v(a, e), i(a, [{
      key: "checkForValidEmail",
      value: function value() {
        console.log("Checking..."), this.state.email.match(L) && "" !== this.state.email ? this.props.onContinue(this.state.email) : this.setState({
          error: "Please enter a valid email address"
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            a = this.state.error;
        return h.a.createElement("div", {
          className: "auth-container"
        }, h.a.createElement("div", {
          className: "form-bg form-short"
        }, a && h.a.createElement("p", {
          className: "alert alert-danger hide",
          id: "errMsg",
          style: {
            display: "block"
          }
        }, a), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          htmlFor: "exampleInputEmail1"
        }, "Enter your email to get started:"), h.a.createElement("input", {
          name: "email",
          autoComplete: "username",
          className: "form-control",
          placeholder: "Enter your email to get started",
          value: this.state.email,
          onChange: function onChange(a) {
            return e.setState({
              email: a.target.value
            });
          },
          onKeyPress: function onKeyPress(a) {
            (a.keyCode || 13 === a.which) && e.checkForValidEmail();
          }
        })), h.a.createElement("div", {
          className: "form-group flex-end-btn"
        }, h.a.createElement("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: this.checkForValidEmail
        }, "Continue"))));
      }
    }]), a;
  }(h.a.Component),
      B = {
    "": [],
    engineering: ["Electrical", "Mechanical", "Industrial", "Design", "Civil", "Architectural", "Computer Science", "Aerospace", "Environmental", "Chemical", "Consulting", "Other"],
    supply: ["Supply Chain", "Purchasing", "Procurement", "Logistics", "Transportation", "Warehousing", "Distribution", "Inventory", "Materials", "Consulting", "Other"],
    manufacturing: ["Manufacturing Engineering", "Production Management", "Quality Control", "Operations", "Maintenance & Repair", "Consulting", "Other"],
    management: ["Engineering Management", "Procurement Management", "Operations Management", "IT", "Other"],
    sales: ["Sales", "Marketing", "Sales & Marketing", "Agencies", "Consulting", "Other"],
    other: ["Consultant", "Student", "Retired", "Educator", "Other"]
  },
      G = function G(e) {
    var a = e.jobFunction;
    return B[a].map(function (e) {
      return h.a.createElement("option", {
        value: e
      }, e);
    });
  };

  function D(e, a) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      a && (n = n.filter(function (a) {
        return Object.getOwnPropertyDescriptor(e, a).enumerable;
      })), t.push.apply(t, n);
    }

    return t;
  }

  var V = {
    firstName: "First Name",
    lastName: "Last Name",
    jobFunction: "Job Function",
    jobLevel: "Industry",
    industry: "Industry",
    companyName: "Company Name",
    country: "Country",
    email: "Email",
    password: "Password"
  };

  function K(e) {
    if (0 === e.length) return !1;

    for (var a = 0; a < e.length; a++) {
      var t = e.substring(a, a + 1);
      if (-1 === "1234567890".indexOf(t, 0)) return !1;
    }

    return !0;
  }

  function H(e) {
    var a = 0;
    if (e.length < 6 || e.length > 20) return !1;

    for (var t = 0; t < e.length; t++) {
      var n = e.substring(t, t + 1);
      if (-1 === "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890".indexOf(n)) return !1;
      K(n) && a++;
    }

    return !(a < 1);
  }

  var q = function (e) {
    function a(e) {
      var t;
      return r(this, a), (t = m(this, p(a).call(this, e))).state = {
        email: e.email,
        firstName: "",
        lastName: "",
        jobFunction: "",
        jobDiscipline: "",
        jobLevel: "",
        industry: "",
        companyName: "",
        companyUrl: "",
        country: "",
        zipCode: "",
        tiu: !0,
        ien: !0,
        password: "",
        noError: !0,
        anyEmpty: !0,
        validPword: !1,
        pressedSubmit: !1
      }, t.onRegister = t.onRegister.bind(u(t)), t.handleInputChange = t.handleInputChange.bind(u(t)), t.handleCheckBoxChange = t.handleCheckBoxChange.bind(u(t)), t;
    }

    return v(a, e), i(a, [{
      key: "handleInputChange",
      value: function value(e) {
        var a,
            t = this,
            n = e.target,
            o = Object.keys(V).filter(function (e) {
          return "" === t.state[e];
        }).some(function (e) {
          return "" !== e;
        }),
            r = H("password" === n.name ? n.value : this.state.password);
        this.setState((P(a = {}, n.name, n.value), P(a, "validPword", r), P(a, "anyEmpty", o), P(a, "noError", !this.state.pressedSubmit || !o && r), a));
      }
    }, {
      key: "handleCheckBoxChange",
      value: function value(e) {
        var a = e.target;
        this.setState(P({}, a.name, a.checked));
      }
    }, {
      key: "onRegister",
      value: function value() {
        var e = this.state,
            a = e.anyEmpty,
            t = e.validPword;
        a || !t ? this.setState({
          noError: !1,
          pressedSubmit: !0
        }) : this.setState({
          noError: !0,
          pressedSubmit: !0
        }, this.props.onSignUp(function (e) {
          for (var a = 1; a < arguments.length; a++) {
            var t = null != arguments[a] ? arguments[a] : {};
            a % 2 ? D(t, !0).forEach(function (a) {
              P(e, a, t[a]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : D(t).forEach(function (a) {
              Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
            });
          }

          return e;
        }({}, this.state)));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            a = this.state,
            t = a.email,
            n = a.firstName,
            o = a.lastName,
            r = a.jobFunction,
            l = a.jobDiscipline,
            i = a.jobLevel,
            c = a.industry,
            s = a.companyName,
            u = a.companyUrl,
            m = a.country,
            p = a.zipCode,
            d = a.tiu,
            v = a.ien,
            f = a.password,
            E = a.noError,
            g = a.anyEmpty,
            b = a.validPword;
        return h.a.createElement("div", {
          className: "auth-container"
        }, h.a.createElement("div", {
          className: "form-bg"
        }, !E && h.a.createElement("p", {
          className: "alert alert-danger hide",
          id: "errMsg",
          style: {
            display: "block"
          }
        }, g && h.a.createElement(h.a.Fragment, null, h.a.createElement("b", null, "Missing Required Fields:"), h.a.createElement("br", null), Object.keys(V).filter(function (a) {
          return "" === e.state[a];
        }).map(function (e) {
          return V[e];
        }).join(", ")), g && !b && h.a.createElement(h.a.Fragment, null, h.a.createElement("br", null), h.a.createElement("br", null)), !b && h.a.createElement(h.a.Fragment, null, h.a.createElement("b", null, "Invalid Login Credentials"), h.a.createElement("br", null), "Passwords may only contain alphanumeric characters, must contain a number, must be at least 6 characters long, and must be no longer than 20 characters")), h.a.createElement("div", null, h.a.createElement("div", {
          className: "cols-2 mt-0 mb-0 clearfix"
        }, h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "firstName"
        }, "First Name"), h.a.createElement("input", {
          id: "firstName",
          name: "firstName",
          value: n,
          maxLength: "100",
          className: "form-control ".concat(E || "" !== n ? "" : "is-invalid"),
          "data-validation": "required",
          type: "text",
          onChange: this.handleInputChange
        })), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "lastName"
        }, "Last Name"), h.a.createElement("input", {
          id: "lastName",
          name: "lastName",
          value: o,
          maxLength: "100",
          className: "form-control ".concat(E || "" !== o ? "" : "is-invalid"),
          "data-validation": "required",
          type: "text",
          onChange: this.handleInputChange
        })), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "jobFunction"
        }, "Job Function"), h.a.createElement("select", {
          name: "jobFunction",
          id: "jobFunction",
          className: "form-control ".concat(E || "" !== r ? "" : "is-invalid"),
          "data-validation": "required",
          value: r,
          onChange: this.handleInputChange
        }, h.a.createElement("option", {
          value: ""
        }, "- Select -"), h.a.createElement("option", {
          value: "engineering"
        }, "Engineering / Design"), h.a.createElement("option", {
          value: "supply"
        }, "Supply Chain / Procurement / Logistics"), h.a.createElement("option", {
          value: "manufacturing"
        }, "Manufacturing / Operations"), h.a.createElement("option", {
          value: "management"
        }, "General Management"), h.a.createElement("option", {
          value: "sales"
        }, "Sales & Marketing"), h.a.createElement("option", {
          value: "other"
        }, "Other"))), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "jobDiscipline"
        }, "Discipline"), h.a.createElement("select", {
          name: "jobDiscipline",
          id: "jobDiscipline",
          className: "form-control",
          disabled: "",
          value: l,
          onChange: this.handleInputChange
        }, h.a.createElement("option", {
          value: ""
        }, "- Select -"), h.a.createElement(G, {
          jobFunction: r
        }))), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "jobLevel"
        }, "Job Level"), h.a.createElement("select", {
          name: "jobLevel",
          id: "jobLevel",
          className: "form-control ".concat(E || "" !== i ? "" : "is-invalid"),
          value: i,
          onChange: this.handleInputChange
        }, h.a.createElement("option", {
          value: ""
        }, "- Select -"), h.a.createElement("option", {
          value: "executive"
        }, "Executive"), h.a.createElement("option", {
          value: "director"
        }, "Director"), h.a.createElement("option", {
          value: "manager"
        }, "Manager"), h.a.createElement("option", {
          value: "individual"
        }, "Individual Contributor"), h.a.createElement("option", {
          value: "owner"
        }, "Owner"))), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "industry"
        }, "Industry"), h.a.createElement("select", {
          name: "industry",
          id: "industry",
          className: "form-control ".concat(E || "" !== c ? "" : "is-invalid"),
          "data-validation": "required",
          value: c,
          onChange: this.handleInputChange
        }, h.a.createElement("option", {
          value: ""
        }, "- Select -"), h.a.createElement("option", {
          value: "Aerospace & Defense"
        }, "Aerospace & Defense"), h.a.createElement("option", {
          value: "Agriculture"
        }, "Agriculture"), h.a.createElement("option", {
          value: "Automotive"
        }, "Automotive"), h.a.createElement("option", {
          value: "Biotech"
        }, "Biotech"), h.a.createElement("option", {
          value: "Business Services"
        }, "Business Services"), h.a.createElement("option", {
          value: "Construction"
        }, "Construction"), h.a.createElement("option", {
          value: "Consumer Goods & Services"
        }, "Consumer Goods & Services"), h.a.createElement("option", {
          value: "Education"
        }, "Education"), h.a.createElement("option", {
          value: "Energy & Utilities"
        }, "Energy & Utilities"), h.a.createElement("option", {
          value: "Engineering Services"
        }, "Engineering Services"), h.a.createElement("option", {
          value: "Facilities & Property Management"
        }, "Facilities & Property Management"), h.a.createElement("option", {
          value: "Food & Beverage"
        }, "Food & Beverage"), h.a.createElement("option", {
          value: "Government & Military"
        }, "Government & Military"), h.a.createElement("option", {
          value: "Healthcare & Medical"
        }, "Healthcare & Medical"), h.a.createElement("option", {
          value: "Hospitality & Travel"
        }, "Hospitality & Travel"), h.a.createElement("option", {
          value: "Manufacturing"
        }, "Manufacturing"), h.a.createElement("option", {
          value: "Marine"
        }, "Marine"), h.a.createElement("option", {
          value: "Mining"
        }, "Mining"), h.a.createElement("option", {
          value: "Pharmaceuticals"
        }, "Pharmaceuticals"), h.a.createElement("option", {
          value: "Printing & Publishing"
        }, "Printing & Publishing"), h.a.createElement("option", {
          value: "Retail & Distribution"
        }, "Retail & Distribution"), h.a.createElement("option", {
          value: "Software & Technology"
        }, "Software & Technology"), h.a.createElement("option", {
          value: "Telecommunications"
        }, "Telecommunications"), h.a.createElement("option", {
          value: "Textiles"
        }, "Textiles"), h.a.createElement("option", {
          value: "Transportation & Logistics"
        }, "Transportation & Logistics"), h.a.createElement("option", {
          value: "Other"
        }, "Other"))), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "companyName"
        }, "Company Name"), h.a.createElement("input", {
          id: "companyName",
          name: "companyName",
          value: s,
          onChange: this.handleInputChange,
          maxLength: "100",
          className: "form-control ".concat(E || "" !== s ? "" : "is-invalid"),
          "data-validation": "required",
          type: "text"
        })), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "companyUrl"
        }, "Company Website"), h.a.createElement("input", {
          id: "companyUrl",
          name: "companyUrl",
          value: u,
          onChange: this.handleInputChange,
          maxLength: "100",
          className: "form-control",
          type: "text"
        })), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "country"
        }, "Country"), h.a.createElement("select", {
          name: "country",
          id: "country",
          className: "form-control chkloc ".concat(E || "" !== m ? "" : "is-invalid"),
          "data-locid": "ucloc",
          "data-validation": "required",
          value: m,
          onChange: this.handleInputChange
        }, h.a.createElement("option", {
          value: ""
        }, "- Select -"), h.a.createElement("option", {
          value: "US"
        }, "United States"), h.a.createElement("option", {
          value: "AF"
        }, "Afghanistan"), h.a.createElement("option", {
          value: "AL"
        }, "Albania"), h.a.createElement("option", {
          value: "DZ"
        }, "Algeria"), h.a.createElement("option", {
          value: "AS"
        }, "American Samoa"), h.a.createElement("option", {
          value: "AD"
        }, "Andorra"), h.a.createElement("option", {
          value: "AO"
        }, "Angola"), h.a.createElement("option", {
          value: "AI"
        }, "Anguilla"), h.a.createElement("option", {
          value: "AQ"
        }, "Antarctica"), h.a.createElement("option", {
          value: "AG"
        }, "Antigua and Barbuda"), h.a.createElement("option", {
          value: "AR"
        }, "Argentina"), h.a.createElement("option", {
          value: "AM"
        }, "Armenia"), h.a.createElement("option", {
          value: "AW"
        }, "Aruba"), h.a.createElement("option", {
          value: "AU"
        }, "Australia"), h.a.createElement("option", {
          value: "AT"
        }, "Austria"), h.a.createElement("option", {
          value: "AZ"
        }, "Azerbaijan"), h.a.createElement("option", {
          value: "BS"
        }, "Bahamas"), h.a.createElement("option", {
          value: "BH"
        }, "Bahrain"), h.a.createElement("option", {
          value: "BD"
        }, "Bangladesh"), h.a.createElement("option", {
          value: "BB"
        }, "Barbados"), h.a.createElement("option", {
          value: "BY"
        }, "Belarus"), h.a.createElement("option", {
          value: "BE"
        }, "Belgium"), h.a.createElement("option", {
          value: "BZ"
        }, "Belize"), h.a.createElement("option", {
          value: "BJ"
        }, "Benin"), h.a.createElement("option", {
          value: "BM"
        }, "Bermuda"), h.a.createElement("option", {
          value: "BT"
        }, "Bhutan"), h.a.createElement("option", {
          value: "BO"
        }, "Bolivia"), h.a.createElement("option", {
          value: "BA"
        }, "Bosnia and Herzegovina"), h.a.createElement("option", {
          value: "BW"
        }, "Botswana"), h.a.createElement("option", {
          value: "BV"
        }, "Bouvet Island"), h.a.createElement("option", {
          value: "BR"
        }, "Brazil"), h.a.createElement("option", {
          value: "IO"
        }, "British Indian Ocean Territory"), h.a.createElement("option", {
          value: "VG"
        }, "British Virgin Islands"), h.a.createElement("option", {
          value: "BN"
        }, "Brunei Darussalam"), h.a.createElement("option", {
          value: "BG"
        }, "Bulgaria"), h.a.createElement("option", {
          value: "BF"
        }, "Burkina Faso"), h.a.createElement("option", {
          value: "BI"
        }, "Burundi"), h.a.createElement("option", {
          value: "KH"
        }, "Cambodia"), h.a.createElement("option", {
          value: "CM"
        }, "Cameroon"), h.a.createElement("option", {
          value: "CA"
        }, "Canada"), h.a.createElement("option", {
          value: "CV"
        }, "Cape Verde"), h.a.createElement("option", {
          value: "KY"
        }, "Cayman Islands"), h.a.createElement("option", {
          value: "CF"
        }, "Central African Republic"), h.a.createElement("option", {
          value: "TD"
        }, "Chad"), h.a.createElement("option", {
          value: "CL"
        }, "Chile"), h.a.createElement("option", {
          value: "CN"
        }, "China"), h.a.createElement("option", {
          value: "CX"
        }, "Christmas Island"), h.a.createElement("option", {
          value: "CC"
        }, "Cocos (Keeling) Islands"), h.a.createElement("option", {
          value: "CO"
        }, "Colombia"), h.a.createElement("option", {
          value: "KM"
        }, "Comoros"), h.a.createElement("option", {
          value: "CG"
        }, "Congo"), h.a.createElement("option", {
          value: "CK"
        }, "Cook Islands"), h.a.createElement("option", {
          value: "CR"
        }, "Costa Rica"), h.a.createElement("option", {
          value: "CI"
        }, "Cote D'Ivoire"), h.a.createElement("option", {
          value: "HR"
        }, "Croatia (Hrvatska)"), h.a.createElement("option", {
          value: "CU"
        }, "Cuba"), h.a.createElement("option", {
          value: "CY"
        }, "Cyprus"), h.a.createElement("option", {
          value: "CZ"
        }, "Czech Republic"), h.a.createElement("option", {
          value: "NF"
        }, "Democratic People's Republic of Korea"), h.a.createElement("option", {
          value: "CD"
        }, "Democratic Republic of Congo"), h.a.createElement("option", {
          value: "DK"
        }, "Denmark"), h.a.createElement("option", {
          value: "DJ"
        }, "Djibouti"), h.a.createElement("option", {
          value: "DM"
        }, "Dominica"), h.a.createElement("option", {
          value: "DO"
        }, "Dominican Republic"), h.a.createElement("option", {
          value: "EC"
        }, "Ecuador"), h.a.createElement("option", {
          value: "EG"
        }, "Egypt"), h.a.createElement("option", {
          value: "SV"
        }, "El Salvador"), h.a.createElement("option", {
          value: "GQ"
        }, "Equatorial Guinea"), h.a.createElement("option", {
          value: "ER"
        }, "Eritrea"), h.a.createElement("option", {
          value: "EE"
        }, "Estonia"), h.a.createElement("option", {
          value: "ET"
        }, "Ethiopia"), h.a.createElement("option", {
          value: "FK"
        }, "Falkland Islands (Malvinas)"), h.a.createElement("option", {
          value: "FO"
        }, "Faroe Islands"), h.a.createElement("option", {
          value: "FM"
        }, "Federated States of Micronesia"), h.a.createElement("option", {
          value: "FJ"
        }, "Fiji"), h.a.createElement("option", {
          value: "FI"
        }, "Finland"), h.a.createElement("option", {
          value: "FR"
        }, "France"), h.a.createElement("option", {
          value: "GF"
        }, "French Guiana"), h.a.createElement("option", {
          value: "PF"
        }, "French Polynesia"), h.a.createElement("option", {
          value: "TF"
        }, "French Southern Territories"), h.a.createElement("option", {
          value: "GA"
        }, "Gabon"), h.a.createElement("option", {
          value: "GM"
        }, "Gambia"), h.a.createElement("option", {
          value: "GE"
        }, "Georgia"), h.a.createElement("option", {
          value: "DE"
        }, "Germany"), h.a.createElement("option", {
          value: "GH"
        }, "Ghana"), h.a.createElement("option", {
          value: "GI"
        }, "Gibraltar"), h.a.createElement("option", {
          value: "GR"
        }, "Greece"), h.a.createElement("option", {
          value: "GL"
        }, "Greenland"), h.a.createElement("option", {
          value: "GD"
        }, "Grenada"), h.a.createElement("option", {
          value: "GP"
        }, "Guadeloupe"), h.a.createElement("option", {
          value: "GU"
        }, "Guam"), h.a.createElement("option", {
          value: "GT"
        }, "Guatemala"), h.a.createElement("option", {
          value: "GN"
        }, "Guinea"), h.a.createElement("option", {
          value: "GW"
        }, "Guinea-Bissau"), h.a.createElement("option", {
          value: "GY"
        }, "Guyana"), h.a.createElement("option", {
          value: "HT"
        }, "Haiti"), h.a.createElement("option", {
          value: "HM"
        }, "Heard Island and MacDonald Islands"), h.a.createElement("option", {
          value: "HN"
        }, "Honduras"), h.a.createElement("option", {
          value: "HK"
        }, "Hong Kong"), h.a.createElement("option", {
          value: "HU"
        }, "Hungary"), h.a.createElement("option", {
          value: "IS"
        }, "Iceland"), h.a.createElement("option", {
          value: "IN"
        }, "India"), h.a.createElement("option", {
          value: "ID"
        }, "Indonesia"), h.a.createElement("option", {
          value: "IQ"
        }, "Iraq"), h.a.createElement("option", {
          value: "IE"
        }, "Ireland"), h.a.createElement("option", {
          value: "IR"
        }, "Islamic Republic of Iran"), h.a.createElement("option", {
          value: "IL"
        }, "Israel"), h.a.createElement("option", {
          value: "IT"
        }, "Italy"), h.a.createElement("option", {
          value: "JM"
        }, "Jamaica"), h.a.createElement("option", {
          value: "JP"
        }, "Japan"), h.a.createElement("option", {
          value: "JO"
        }, "Jordan"), h.a.createElement("option", {
          value: "KZ"
        }, "Kazakhstan"), h.a.createElement("option", {
          value: "KE"
        }, "Kenya"), h.a.createElement("option", {
          value: "KI"
        }, "Kiribati"), h.a.createElement("option", {
          value: "KR"
        }, "Korea"), h.a.createElement("option", {
          value: "KW"
        }, "Kuwait"), h.a.createElement("option", {
          value: "KG"
        }, "Kyrgyzstan"), h.a.createElement("option", {
          value: "LA"
        }, "Laos"), h.a.createElement("option", {
          value: "LV"
        }, "Latvia"), h.a.createElement("option", {
          value: "LB"
        }, "Lebanon"), h.a.createElement("option", {
          value: "LS"
        }, "Lesotho"), h.a.createElement("option", {
          value: "LR"
        }, "Liberia"), h.a.createElement("option", {
          value: "LY"
        }, "Libyan Arab Jamahiriya"), h.a.createElement("option", {
          value: "LI"
        }, "Liechtenstein"), h.a.createElement("option", {
          value: "LT"
        }, "Lithuania"), h.a.createElement("option", {
          value: "LU"
        }, "Luxembourg"), h.a.createElement("option", {
          value: "MO"
        }, "Macao"), h.a.createElement("option", {
          value: "MK"
        }, "Macedonia"), h.a.createElement("option", {
          value: "MG"
        }, "Madagascar"), h.a.createElement("option", {
          value: "MW"
        }, "Malawi"), h.a.createElement("option", {
          value: "MY"
        }, "Malaysia"), h.a.createElement("option", {
          value: "MV"
        }, "Maldives"), h.a.createElement("option", {
          value: "ML"
        }, "Mali"), h.a.createElement("option", {
          value: "MT"
        }, "Malta"), h.a.createElement("option", {
          value: "MH"
        }, "Marshall Islands"), h.a.createElement("option", {
          value: "MQ"
        }, "Martinique"), h.a.createElement("option", {
          value: "MR"
        }, "Mauritania"), h.a.createElement("option", {
          value: "MU"
        }, "Mauritius"), h.a.createElement("option", {
          value: "YT"
        }, "Mayotte"), h.a.createElement("option", {
          value: "MX"
        }, "Mexico"), h.a.createElement("option", {
          value: "MD"
        }, "Moldova"), h.a.createElement("option", {
          value: "MC"
        }, "Monaco"), h.a.createElement("option", {
          value: "MN"
        }, "Mongolia"), h.a.createElement("option", {
          value: "MS"
        }, "Montserrat"), h.a.createElement("option", {
          value: "MA"
        }, "Morocco"), h.a.createElement("option", {
          value: "MZ"
        }, "Mozambique"), h.a.createElement("option", {
          value: "MM"
        }, "Myanmar"), h.a.createElement("option", {
          value: "NA"
        }, "Namibia"), h.a.createElement("option", {
          value: "NR"
        }, "Nauru"), h.a.createElement("option", {
          value: "NP"
        }, "Nepal"), h.a.createElement("option", {
          value: "NL"
        }, "Netherlands"), h.a.createElement("option", {
          value: "AN"
        }, "Netherlands Antilles"), h.a.createElement("option", {
          value: "NC"
        }, "New Caledonia"), h.a.createElement("option", {
          value: "NZ"
        }, "New Zealand"), h.a.createElement("option", {
          value: "NI"
        }, "Nicaragua"), h.a.createElement("option", {
          value: "NE"
        }, "Niger"), h.a.createElement("option", {
          value: "NG"
        }, "Nigeria"), h.a.createElement("option", {
          value: "NU"
        }, "Niue"), h.a.createElement("option", {
          value: "MP"
        }, "Northern Mariana Islands"), h.a.createElement("option", {
          value: "NO"
        }, "Norway"), h.a.createElement("option", {
          value: "OM"
        }, "Oman"), h.a.createElement("option", {
          value: "PK"
        }, "Pakistan"), h.a.createElement("option", {
          value: "PW"
        }, "Palau"), h.a.createElement("option", {
          value: "PA"
        }, "Panama"), h.a.createElement("option", {
          value: "PG"
        }, "Papua New Guinea"), h.a.createElement("option", {
          value: "PY"
        }, "Paraguay"), h.a.createElement("option", {
          value: "PE"
        }, "Peru"), h.a.createElement("option", {
          value: "PH"
        }, "Philippines"), h.a.createElement("option", {
          value: "PN"
        }, "Pitcairn"), h.a.createElement("option", {
          value: "PL"
        }, "Poland"), h.a.createElement("option", {
          value: "PT"
        }, "Portugal"), h.a.createElement("option", {
          value: "PR"
        }, "Puerto Rico"), h.a.createElement("option", {
          value: "QA"
        }, "Qatar"), h.a.createElement("option", {
          value: "RE"
        }, "Reunion"), h.a.createElement("option", {
          value: "RO"
        }, "Romania"), h.a.createElement("option", {
          value: "RU"
        }, "Russian Federation"), h.a.createElement("option", {
          value: "RW"
        }, "Rwanda"), h.a.createElement("option", {
          value: "SH"
        }, "Saint Helena"), h.a.createElement("option", {
          value: "KN"
        }, "Saint Kitts and Nevis"), h.a.createElement("option", {
          value: "LC"
        }, "Saint Lucia"), h.a.createElement("option", {
          value: "PM"
        }, "Saint Pierre and Miquelon"), h.a.createElement("option", {
          value: "VC"
        }, "Saint Vincent and the Grenadines"), h.a.createElement("option", {
          value: "WS"
        }, "Samoa"), h.a.createElement("option", {
          value: "SM"
        }, "San Marino"), h.a.createElement("option", {
          value: "ST"
        }, "Sao Tome and Principe"), h.a.createElement("option", {
          value: "SA"
        }, "Saudi Arabia"), h.a.createElement("option", {
          value: "SN"
        }, "Senegal"), h.a.createElement("option", {
          value: "SC"
        }, "Seychelles"), h.a.createElement("option", {
          value: "SL"
        }, "Sierra Leone"), h.a.createElement("option", {
          value: "SG"
        }, "Singapore"), h.a.createElement("option", {
          value: "SK"
        }, "Slovakia"), h.a.createElement("option", {
          value: "SI"
        }, "Slovenia"), h.a.createElement("option", {
          value: "SB"
        }, "Solomon Islands"), h.a.createElement("option", {
          value: "SO"
        }, "Somalia"), h.a.createElement("option", {
          value: "ZA"
        }, "South Africa"), h.a.createElement("option", {
          value: "GS"
        }, "South Georgia and..."), h.a.createElement("option", {
          value: "ES"
        }, "Spain"), h.a.createElement("option", {
          value: "LK"
        }, "Sri Lanka"), h.a.createElement("option", {
          value: "SD"
        }, "Sudan"), h.a.createElement("option", {
          value: "SR"
        }, "Suriname"), h.a.createElement("option", {
          value: "SJ"
        }, "Svalbard and Jan Mayen"), h.a.createElement("option", {
          value: "SZ"
        }, "Swaziland"), h.a.createElement("option", {
          value: "SE"
        }, "Sweden"), h.a.createElement("option", {
          value: "CH"
        }, "Switzerland"), h.a.createElement("option", {
          value: "SY"
        }, "Syrian Arab Republic"), h.a.createElement("option", {
          value: "TW"
        }, "Taiwan"), h.a.createElement("option", {
          value: "TJ"
        }, "Tajikistan"), h.a.createElement("option", {
          value: "TH"
        }, "Thailand"), h.a.createElement("option", {
          value: "TG"
        }, "Togo"), h.a.createElement("option", {
          value: "TK"
        }, "Tokelau"), h.a.createElement("option", {
          value: "TO"
        }, "Tonga"), h.a.createElement("option", {
          value: "TT"
        }, "Trinidad and Tobago"), h.a.createElement("option", {
          value: "TN"
        }, "Tunisia"), h.a.createElement("option", {
          value: "TR"
        }, "Turkey"), h.a.createElement("option", {
          value: "TM"
        }, "Turkmenistan"), h.a.createElement("option", {
          value: "TC"
        }, "Turks and Caicos Islands"), h.a.createElement("option", {
          value: "TV"
        }, "Tuvalu"), h.a.createElement("option", {
          value: "UG"
        }, "Uganda"), h.a.createElement("option", {
          value: "UA"
        }, "Ukraine"), h.a.createElement("option", {
          value: "AE"
        }, "United Arab Emirates"), h.a.createElement("option", {
          value: "GB"
        }, "United Kingdom"), h.a.createElement("option", {
          value: "TZ"
        }, "United Republic of Tanzania"), h.a.createElement("option", {
          value: "UM"
        }, "United States Minor Outlying Islands"), h.a.createElement("option", {
          value: "VI"
        }, "United States Virgin Islands"), h.a.createElement("option", {
          value: "UY"
        }, "Uruguay"), h.a.createElement("option", {
          value: "UZ"
        }, "Uzbekistan"), h.a.createElement("option", {
          value: "VU"
        }, "Vanuatu"), h.a.createElement("option", {
          value: "VA"
        }, "Vatican"), h.a.createElement("option", {
          value: "VE"
        }, "Venezuela"), h.a.createElement("option", {
          value: "VN"
        }, "Vietnam"), h.a.createElement("option", {
          value: "WF"
        }, "Wallis and Futuna"), h.a.createElement("option", {
          value: "EH"
        }, "Western Sahara"), h.a.createElement("option", {
          value: "YE"
        }, "Yemen"), h.a.createElement("option", {
          value: "ZM"
        }, "Zambia"), h.a.createElement("option", {
          value: "ZW"
        }, "Zimbabwe"))), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "zipCode",
          id: "lblZip"
        }, "Zip/Postal Code"), h.a.createElement("input", {
          id: "zipCode",
          name: "zipCode",
          maxLength: "15",
          className: "form-control",
          type: "text",
          value: p,
          onChange: this.handleInputChange
        })), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "email"
        }, "Email Address"), h.a.createElement("input", {
          id: "email",
          name: "email",
          value: t,
          onChange: this.handleInputChange,
          maxLength: "100",
          autoComplete: "email",
          className: "form-control ".concat(E || "" !== t ? "" : "is-invalid"),
          "data-validation": "required",
          type: "email"
        })), h.a.createElement("div", {
          className: "form-group"
        }, h.a.createElement("label", {
          className: "",
          htmlFor: "password"
        }, "Password"), h.a.createElement("input", {
          id: "password",
          name: "password",
          className: "pword form-control ".concat(E || H(f) ? "" : "is-invalid"),
          value: f,
          onChange: this.handleInputChange,
          maxLength: "30",
          autoComplete: "new-password",
          "data-validation": "required",
          type: "password",
          "aria-autocomplete": "list"
        }))), h.a.createElement("div", {
          className: "input-row optin subs"
        }), h.a.createElement("div", {
          className: "form-check optin subs mb-0"
        }, h.a.createElement("input", {
          name: "xtsubs",
          id: "xtsubs",
          value: "1",
          type: "hidden"
        }), h.a.createElement("input", {
          name: "xtemail",
          id: "xtemail",
          value: "",
          type: "hidden"
        }), h.a.createElement("label", {
          className: "form-check-label"
        }, h.a.createElement("input", {
          className: "form-check-input",
          checked: d,
          onChange: this.handleCheckBoxChange,
          name: "tiu",
          id: "newslettersub",
          type: "checkbox"
        }), "Yes, I want the ", h.a.createElement("i", null, "Thomas Industry Update"), " newsletter.", " ")), h.a.createElement("div", {
          className: "form-check optin mb-3"
        }, h.a.createElement("label", {
          className: "form-check-label"
        }, h.a.createElement("input", {
          className: "form-check-input",
          onChange: this.handleCheckBoxChange,
          name: "ien",
          id: "ien",
          checked: v,
          type: "checkbox"
        }), "Yes, I want more information on ", h.a.createElement("i", null, "Industrial Equipment News"), " ", "(IEN).")), h.a.createElement("div", {
          className: "form-group text-center mb-0"
        }, h.a.createElement("div", {
          className: "button-spinner-wrap"
        }, h.a.createElement("button", {
          className: "btn btn-primary btn-lg",
          onClick: this.onRegister
        }, this.props.loading ? h.a.createElement("div", {
          className: "spinner loading-white"
        }, h.a.createElement("div", {
          className: "rect1"
        }), h.a.createElement("div", {
          className: "rect2"
        }), h.a.createElement("div", {
          className: "rect3"
        }), h.a.createElement("div", {
          className: "rect4"
        }), h.a.createElement("div", {
          className: "rect5"
        })) : h.a.createElement(h.a.Fragment, null, "Next →")))), h.a.createElement("input", {
          type: "hidden",
          id: "ORIGIN",
          name: "ORIGIN",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "adcode",
          name: "adcode",
          value: "regform"
        }), h.a.createElement("input", {
          type: "hidden",
          id: "corptandc",
          name: "corptandc",
          value: "y"
        }), h.a.createElement("input", {
          type: "hidden",
          id: "cro_test",
          name: "cro_test",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "email2",
          name: "email2",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "frequency",
          name: "frequency",
          value: "day"
        }), h.a.createElement("input", {
          type: "hidden",
          id: "origin",
          name: "origin",
          value: "main"
        }), h.a.createElement("input", {
          type: "hidden",
          id: "origin_2",
          name: "origin_2",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "pword2",
          name: "pword2",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "rt",
          name: "rt",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "rwid",
          name: "rwid",
          value: ""
        }), h.a.createElement("input", {
          type: "hidden",
          id: "subopts",
          name: "subopts",
          value: "YID|IEN"
        }))));
      }
    }]), a;
  }(h.a.Component),
      z = t(6),
      J = t.n(z);

  function W(e, a, t, n, o, r, l) {
    try {
      var i = e[r](l),
          c = i.value;
    } catch (e) {
      return void t(e);
    }

    i.done ? a(c) : Promise.resolve(c).then(n, o);
  }

  var Z = t(2),
      Y = t.n(Z),
      Q = {
    path: "/",
    domain: ".thomasnet.com"
  },
      X = function (e) {
    function a(e) {
      var t;
      return r(this, a), (t = m(this, p(a).call(this, e))).state = {
        isSignedIn: !1,
        loading: !1
      }, t.signIn = t.signIn.bind(u(t)), t.signUp = t.signUp.bind(u(t)), t.logOut = t.logOut.bind(u(t)), t.forgotPassword = t.forgotPassword.bind(u(t)), t.confirmForgotPassword = t.confirmForgotPassword.bind(u(t)), t;
    }

    return v(a, e), i(a, [{
      key: "success",
      value: function value() {
        this.setState({
          isSignedIn: !0,
          loading: !1
        });
      }
    }, {
      key: "componentWillMount",
      value: function value() {
        var e = this;
        this.setState({
          loading: !0
        }, function () {
          e.isSignedIn().then(function (a) {
            a && e.success();
          });
        });
      }
    }, {
      key: "setAuthTokens",
      value: function value(e) {
        var a = e.accessToken,
            t = e.idToken,
            n = e.refreshToken;
        window.localStorage.setItem("access_token", a), window.localStorage.setItem("id_token", t), window.localStorage.setItem("refresh_token", n);
      }
    }, {
      key: "getAuthCookies",
      value: function value() {
        return {
          tinid: Y.a.load("tinid"),
          coreX: Y.a.load("core_x"),
          coreU: Y.a.load("core_u")
        };
      }
    }, {
      key: "setAuthCookies",
      value: function value(e) {
        var a = e.tinid,
            t = e.coreX,
            n = e.coreU;
        Y.a.save("tinid", a, Q), Y.a.save("core_x", t, Q), Y.a.save("core_u", n, Q);
      }
    }, {
      key: "isSignedIn",
      value: function value() {
        var e = this,
            a = this.getAuthCookies(),
            t = a.tinid,
            n = a.coreX,
            o = a.coreU;
        return n && o ? this.props.authService.amISignedIn(t, n, o).then(function (a) {
          return !(!a || !a.cognito) && (e.setAuthTokens({
            accessToken: a.cognito.AccessToken,
            idToken: a.cognito.IdToken,
            refreshToken: a.cognito.RefreshToken
          }), !0);
        }).catch(function (e) {
          return console.log("[AuthContainer.isSignedIn] authService err:", e), !1;
        }) : Promise.resolve(!1);
      }
    }, {
      key: "signIn",
      value: function value(e, a) {
        var t = this;
        return this.props.authService.signIn(e, a).then(function (e) {
          t.setAuthCookies({
            tinid: e.userId,
            coreX: e.core_x,
            coreU: e.core_u
          }), t.setAuthTokens({
            accessToken: e.access_token,
            idToken: e.id_token,
            refreshToken: e.refresh_token
          }), t.success();
        }).catch(function (e) {
          throw console.error("[signIn] err:", e), e;
        });
      }
    }, {
      key: "signUp",
      value: function value(e) {
        var a = this;
        return this.props.authService.signUp(e).then(function () {
          var t,
              n = (t = J.a.mark(function t(n) {
            return J.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.next = 2, a.signIn(e.email, e.password);

                  case 2:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }), function () {
            var e = this,
                a = arguments;
            return new Promise(function (n, o) {
              var r = t.apply(e, a);

              function l(e) {
                W(r, n, o, l, i, "next", e);
              }

              function i(e) {
                W(r, n, o, l, i, "throw", e);
              }

              l(void 0);
            });
          });
          return function (e) {
            return n.apply(this, arguments);
          };
        }()).catch(function (e) {
          throw console.error("[singUp] err:", e), e;
        });
      }
    }, {
      key: "logOut",
      value: function value(e) {
        Y.a.remove("tinid", Q), Y.a.remove("core_x", Q), Y.a.remove("core_u", Q), window.localStorage.removeItem("access_token"), window.localStorage.removeItem("id_token"), window.localStorage.removeItem("refresh_token"), window.location.href = e;
      }
    }, {
      key: "forgotPassword",
      value: function value(e) {
        return this.props.authService.forgotPassword(e).then(function (e) {
          return e;
        }).catch(function (e) {
          throw console.error(e), e;
        });
      }
    }, {
      key: "confirmForgotPassword",
      value: function value(e, a, t, n) {
        return this.props.authService.confirmForgotPassword(e, a, t, n).then(function (e) {
          return e;
        }).catch(function (e) {
          throw console.error(e), e;
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.state,
            a = e.isSignedIn,
            t = e.loading;
        return this.props.children({
          signIn: this.signIn,
          signUp: this.signUp,
          logOut: this.logOut,
          forgotPassword: this.forgotPassword,
          confirmForgotPassword: this.confirmForgotPassword,
          isSignedIn: a,
          loading: t
        });
      }
    }]), a;
  }(h.a.Component);

  t.d(a, "BooleanCheckbox", function () {
    return g;
  }), t.d(a, "StackedRadioGroup", function () {
    return y;
  }), t.d(a, "InlineRadioGroup", function () {
    return N;
  }), t.d(a, "FileUploadForm", function () {
    return _;
  }), t.d(a, "FileUploadInput", function () {
    return T;
  }), t.d(a, "FileUploadList", function () {
    return O;
  }), t.d(a, "StackedText", function () {
    return C;
  }), t.d(a, "StackedSelect", function () {
    return S;
  }), t.d(a, "StackedDatePicker", function () {
    return M;
  }), t.d(a, "StackedTextArea", function () {
    return F;
  }), t.d(a, "TestButton", function () {
    return A;
  }), t.d(a, "SignInEmail", function () {
    return R;
  }), t.d(a, "SignInPassword", function () {
    return j;
  }), t.d(a, "SignUp", function () {
    return q;
  }), t.d(a, "ResetPassword", function () {
    return U;
  }), t.d(a, "AuthContainer", function () {
    return X;
  });
}]));